import {Link, useLocation} from 'react-router-dom';
import './Header.css';

type LinkInfo = {
	url: string;
	title: string;
};

export const Header = () => {
	const theLocation = useLocation();
	const activeClass = 'link--selected';
	const inActiveClass = 'link';
	const links: LinkInfo[] = [
		{url: '/data-format', title: 'Data format'},
		{url: '/security', title: 'Security'},
		{url: '/banner', title: 'SB Banner'},
		{url: '/docker', title: 'Docker'},
		{url: '/base64', title: 'Base64'},
		{url: '/cheat-sheets', title: 'Cheat Sheets'},
		{url: '/templates', title: 'Templates'},
		{url: '/ukraine', title: 'Ukraine'},
	];
	const linkJSX = links.map((e) => {
		return (
			<li
				key={e.title}
				className={
					theLocation.pathname.includes(e.url) ? activeClass : inActiveClass
				}
			>
				<Link to={e.url}>{e.title}</Link>
			</li>
		);
	});
	return (
		<div key='header_div' className='header'>
			<div key='header_div_logo' className='header__logo'>
				<Link to='/'>Code Investigator</Link>
			</div>
			<div key='header_div_container' className='header__container'>
				<ul>{linkJSX}</ul>
			</div>
		</div>
	);
};
